import { motion } from "framer-motion";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    label: "Split AC — Full Service",
    span: "md:col-span-2 md:row-span-2",
    h: "h-[320px] md:h-full",
  },
  {
    src: "https://images.unsplash.com/photo-1626806819282-2c1dc01a5e0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    label: "Washing Machine Repair",
    span: "md:col-span-1",
    h: "h-[320px] md:h-full",
  },
  {
    src: "https://images.unsplash.com/photo-1562941995-17dc31eaaf6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    label: "Precision Bench Work",
    span: "md:col-span-1",
    h: "h-[320px] md:h-full",
  },
  {
    src: "https://customer-assets-jai6qajn.emergentagent.net/job_manasa-electrical/artifacts/muyez1ur_WhatsApp%20Image%202026-08-20%20at%202.23.45%20PM.jpeg",
    label: "Inside Our Workshop — TV Repair Bench",
    span: "md:col-span-2",
    h: "h-[320px] md:h-full",
  },
  {
    src: "https://customer-assets-jai6qajn.emergentagent.net/job_manasa-electrical/artifacts/6z9aqpi1_WhatsApp%20Image%202026-08-20%20at%202.22.26%20PM.jpeg",
    label: "Our Service Desk",
    span: "md:col-span-1",
    h: "h-[320px] md:h-full",
  },
];

export const Gallery = () => {
  return (
    <section id="work" data-testid="gallery-section" className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40">
      <div className="flex items-end justify-between mb-16 md:mb-24">
        <h2 className="font-display font-bold uppercase tracking-tight text-white text-4xl md:text-6xl lg:text-7xl leading-[0.9]">
          The Work
        </h2>
        <span className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-mono-plex font-bold hidden md:block">
          [ 03 — Field & Bench ]
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-[330px] gap-3 md:gap-4">
        {IMAGES.map((img, i) => (
          <motion.div
            key={img.label}
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`gallery-item-${i}`}
            className={`group relative overflow-hidden bg-[#0D0D0D] border border-[#222222] ${img.span} ${img.h}`}
          >
            <img
              src={img.src}
              alt={img.label}
              className="w-full h-full object-cover grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] to-transparent opacity-70" />
            <div className="absolute bottom-0 left-0 p-5 md:p-6 flex items-center gap-3">
              <span className="w-2 h-2 bg-[#FF3B30]" />
              <span className="font-mono-plex text-white uppercase tracking-[0.15em] text-xs">
                {img.label}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
